export const LOADING_STARTED = 'LOADING_STARTED';
export const VAT_RECORDS_LOADED = 'VAT_RECORDS_LOADED';
export const VAT_SCHEME_LOADED = 'VAT_SCHEME_LOADED';
